import React, { useEffect, useMemo } from 'react';
import { Link, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { fetchLatestTasks } from '../../redux/actions/taskActions';
import RyffineTable from '../common/RyffineTable';
import { formatDateStr } from '../../core/services/commonService';
import { TASKS_ROUTE } from '../../core/constants';
import { generateStatusField } from '../common/Utility';
import { APP_ENV } from '../../config';
import { loadProjects } from '../../redux/actions/projectsActions';

const getUUIDForCollegeBoard = task => {
  if (task.converter === 'evaluation') {
    const config = JSON.parse(task.config || '{}');

    if (Object.prototype.hasOwnProperty.call(config, 'friendly_name') && config.friendly_name !== '') {
      return <Link to={`${TASKS_ROUTE}/${task.id}`} component={RouterLink}>{config.friendly_name}</Link>;
    }
  }

  return <Link to={`${TASKS_ROUTE}/${task.id}`} component={RouterLink}>{task.source.split('/').pop()}</Link>;
};

const getTaskLink = task => {
  let uuidValue = task.id;
  if (!(task.name === null || task.name === undefined || task.name.trim() === '')) {
    let taskName = task.name.trim();

    if (taskName.length > 65) {
      taskName = `${taskName.slice(0, 49)}...`;
    }

    uuidValue = taskName;
  }

  return <Link to={`${TASKS_ROUTE}/${task.id}`} component={RouterLink}>{uuidValue}</Link>;
};

const generateTableRows = (tasks, projects) => (
  tasks
    .map((task, index) => {
      const project = projects.projects.find(p => p.id === task.project_id);
      const projectName = project ? project.name : 'No Project';

      if (APP_ENV === 'collegeBoard') {
        return {
          id: index,
          uuid: {
            value: task.id,
            displayValue: getUUIDForCollegeBoard(task),
          },
          converter: task.converter,
          tag: task.tag,
          status: {
            value: task.status,
            displayValue: generateStatusField(task.status),
          },
          created: {
            value: task.created,
            displayValue: formatDateStr(task.created) || 'N/A',
          },
        };
      }

      return {
        id: index,
        uuid: {
          value: task.id,
          displayValue: getTaskLink(task),
        },
        converter: task.converter,
        tag: task.tag,
        project: projectName,
        status: {
          value: task.status,
          displayValue: generateStatusField(task.status),
        },
        created: {
          value: task.created,
          displayValue: formatDateStr(task.created) || 'N/A',
        },
      };
    })
);

const columns = APP_ENV === 'collegeBoard' ? [
  {
    field: 'uuid', headerName: 'Friendly Name / Source filename', sortable: true, flex: 1,
  },
  {
    field: 'converter', headerName: 'Type', sortable: true, flex: 0.5,
  },
  {
    field: 'tag', headerName: 'Release', sortable: true, flex: 0.5,
  },
  {
    field: 'status', headerName: 'Status', sortable: true, flex: 0.5,
  },
  {
    field: 'created', headerName: 'Date created', sortable: true, flex: 0.75,
  },
] : [
  {
    field: 'uuid', headerName: 'UUID / Name', sortable: true, flex: 1,
  },
  {
    field: 'project', headerName: 'Project', sortable: true, flex: 0.5,
  },
  {
    field: 'converter', headerName: 'Type', sortable: true, flex: 0.5,
  },
  {
    field: 'tag', headerName: 'Release', sortable: true, flex: 0.5,
  },
  {
    field: 'status', headerName: 'Status', sortable: true, flex: 0.5,
  },
  {
    field: 'created', headerName: 'Date created', sortable: true, flex: 0.75,
  },
];

export default function LatestTasks() {
  const dispatch = useDispatch();

  const { tasks, loading } = useSelector(state => state.task.latestTasks);

  const projects = useSelector(state => state.projects);

  useEffect(() => {
    dispatch(loadProjects());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLatestTasks());
  }, [dispatch]);

  const tableRows = useMemo(() => generateTableRows(tasks, projects), [tasks, projects]);

  return (
    <RyffineTable
      tableContainerProps={{
        className: `${RyffineTable.defaultProps.tableContainerProps.className} latest-tasks`,
        component: Paper,
      }}
      lastRecordWithoutBorder
      displayPagination={false}
      columns={columns}
      loading={loading}
      rows={tableRows}
      initSorting={{
        order: 'desc',
        field: 'created',
      }}
    />
  );
}
